<main class="container">
    <!-- <div class="container"> -->
    <div class="row">
        <div class="col-12">
            <div class="formulario">
                <input value="Alterar Senha" class="btn-sucesso" type="submit" (click)="edited = !edited">
                <form [formGroup]="formUsuario" (ngSubmit)="atualizar()">
                    <h1>Editar Usuário</h1>
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <label id="label-input">
                                    <span>Nome:</span>
                                    <input type="text" formControlName="vc_nome" class="input form-control "
                                        name="usuario.vc_nome" id="nome">
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label id="label-input">
                                    <span>Email:</span>
                                    <input formControlName="vc_login" class="input form-control" type="email"
                                        name="usuario.vc_login" id="login">
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label id="label-input" for="telefone">
                                    <span>Telefone:</span>
                                    <input formControlName="vc_telefone" class="input form-control" type="text"
                                        (input)="onInputChange()" name="telefone" id="telefone" mask="00(00) 00000-0000"
                                        prefix="+">
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label id="label-input" *ngIf="edited">
                                    <span>Senha:</span>
                                    <input formControlName="vc_senha" class="input form-control" type="password"
                                        id="senha" name="usuario.vc_senha">
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <label>
                                    <span>Clientes:</span>
                                </label>
                                <mat-select #selectClientes id="selectClientes" formControlName="ar_clientes" class="input form-control"
                                    multiple>
                                    <mat-select-trigger *ngIf="opcaoTodosClientes.selected">
                                        Todos os clientes
                                    </mat-select-trigger>
                                    <mat-option #opcaoTodosClientes (click)="selecionarService.selecionarTodosClientes(selectClientes, opcaoTodosClientes)">Todos os
                                        clientes</mat-option>
                                    <div *ngFor="let cliente of clientes">
                                        <mat-option [value]="cliente.sr_id" (click)="selecionarService.verificarSelecionarTodos(formUsuario, 'ar_clientes', opcaoTodosClientes, clientes)">{{cliente.vc_nome}}</mat-option>
                                    </div>
                                </mat-select>
                            </div>
                            <div class="col-md-6">
                                <label>
                                    <span>Grupos:</span>
                                </label>
                                <mat-select formControlName="ar_grupos" class="input form-control" multiple>
                                    <div *ngFor="let grupo of grupos">
                                        <mat-option [value]="grupo.sr_id">{{grupo.vc_nome}}</mat-option>
                                    </div>
                                </mat-select>
                            </div>
                        </div>
                    </div>


                    <!-- <label for="">
                <span>Clientes</span>
            </label> -->
                    <!-- <div id="label-clientes" for="cliente">
              <ul>
                  <div id="checkbox">
                      <li formGroupName="ar_clientes" *ngFor="let cliente of clientes; let i=index">
                          <label class="checkbox">
                            <input class="checkbox" type="checkbox" [value]="cliente.sr_id" [checked]="checarCliente(cliente.sr_id)" (change)="onCheckboxChangeCliente($event)" name="clientes">
                            {{cliente.vc_nome}}
                          </label>
                      </li>
                  </div>
              </ul>
                </div> -->
                    <!-- <label id="label-checkbox">
                  <span>Grupos:</span>
              </label> -->
                    <!-- <div id="container-checkbox">
                <ul>
                    <div id="checkbox">
                        <li formGroupName="ar_grupos" *ngFor="let grupo of grupos; let i=index">
                            <label class="checkbox">
                                <input type="checkbox" value="{{grupo.sr_id}}" [checked]="checarGrupo(grupo.sr_id)" (change)="onCheckboxChangeGrupo($event)" class="checkbox" name="grupo">
                                {{grupo.vc_nome}}
                            </label>
                        </li>
                    </div>
                </ul>
            </div> -->
                    <div id="buttons">
                        <button class="btn-sucesso" [disabled]="formUsuario.invalid" type="submit">Editar</button>
                        <button (click)="cancel()" class="btn-cancelar" type="btn">Cancelar</button>
                    </div>

                </form>
            </div>
        </div>
    </div>
    <div class="load" *ngIf="load">
        <mat-progress-spinner diameter=30 class="example-margin" [color]="color" [mode]="mode" [value]="value">
        </mat-progress-spinner>
    </div>
    <!-- </div> -->
</main>